import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { renderContentfulComponent } from "@lululemon/cosy-contentful-renderer";
import { baseRenderContentType } from "@lululemon/ui-library";

import StoryBlockText from "./story-block-text";
import WhyYouLoveThisMaterialAndCare from "../why-you-love-this-material-and-care";

import styles from "./story-blocks.module.scss";

function StoryBlocksDesktop({ storyBlocks, materialAndCare, doubleLinedText }) {
  const mediaItems = useMemo(
    () =>
      storyBlocks
        ?.reduce(
          (previous, storyBlock) =>
            storyBlock?.fields?.media
              ? previous.concat(storyBlock?.fields?.media)
              : previous,
          []
        )
        .slice(0, 3),
    [storyBlocks]
  );

  return (
    <div className="lll-grid">
      <div className={styles.mediaBlock}>
        {mediaItems &&
          mediaItems.map((media) => (
            <div key={media.sys?.id} className={styles.mediaBlockItem}>
              {renderContentfulComponent({
                contentfulComponent: {
                  ...media,
                  fields: { ...media?.fields, autoplay: true }
                },
                options: {
                  renderContentType: baseRenderContentType
                }
              })}
            </div>
          ))}
      </div>
      <div className={styles.textBlock}>
        {storyBlocks?.map(({ fields, sys: { id } }) => (
          <StoryBlockText key={id} {...fields} />
        ))}
        {(materialAndCare || doubleLinedText) && (
          <WhyYouLoveThisMaterialAndCare
            materialAndCare={materialAndCare}
            doubleLinedText={doubleLinedText}
          />
        )}
      </div>
    </div>
  );
}

StoryBlocksDesktop.propTypes = {
  storyBlocks: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({
        description: PropTypes.string.isRequired,
        media: PropTypes.arrayOf(
          PropTypes.shape({
            fields: PropTypes.shape({
              description: PropTypes.string,
              imageUrl: PropTypes.string,
              mobileImageUrl: PropTypes.string,
              title: PropTypes.string,
              videoCaptionsUrl: PropTypes.string,
              videoPreviewImageUrl: PropTypes.string,
              videoUrl: PropTypes.string
            }),
            sys: PropTypes.shape({
              contentType: PropTypes.shape({
                sys: PropTypes.shape({
                  id: PropTypes.string
                })
              }),
              id: PropTypes.string
            })
          })
        ),
        scaleImage: PropTypes.shape({
          fields: PropTypes.shape({
            description: PropTypes.string,
            imageUrl: PropTypes.string,
            mobileImageUrl: PropTypes.string
          })
        }),
        title: PropTypes.string.isRequired
      }),
      sys: PropTypes.shape({
        id: PropTypes.string
      })
    })
  ),
  materialAndCare: PropTypes.object,
  doubleLinedText: PropTypes.string
};

StoryBlocksDesktop.defaultProps = {
  storyBlocks: []
};

export default StoryBlocksDesktop;
